export default __webpack_public_path__ + "static/media/1890.e5bd04e1.png";